export var isBrowser = typeof window === 'object';
export var isMsEdge = function isMsEdge() {
  return CSS && typeof CSS.supports === 'function' && CSS.supports('-ms-ime-align', 'auto');
};
export var isIE11 = function isIE11() {
  return isBrowser && window.navigator.userAgent.indexOf('Trident/') > 0;
};
export var isIE11OrBelow = function isIE11OrBelow() {
  return navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
};
export var Device;

(function (Device) {
  Device["IOS"] = "IOS";
  Device["Android"] = "Android";
  Device["Other"] = "Other";
})(Device || (Device = {}));

export var toDevice = function toDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  if (isIOS(userAgent)) {
    return Device.IOS;
  } else if (isAndroid(userAgent)) {
    return Device.Android;
  } else {
    return Device.Other;
  }
};
export var isIOS = function isIOS() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return !!userAgent.match(/iPhone|iPod|iPad/);
};
export var isAndroid = function isAndroid() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return !!userAgent.match(/android/i);
}; // TODO: use https://github.com/omrilotan/isbot

var ROBOT_CHECK = /facebookexternalhit|facebot|prerender|checklyhq/i;
export var isRobot = function isRobot() {
  var _window, _window$navigator;

  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isBrowser ? (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent : '';
  return ROBOT_CHECK.test(userAgent);
};
export var isChrome = function isChrome() {
  var _window$navigator$use;

  return /chrom/i.test((_window$navigator$use = window.navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : '');
};
export var supportsPositionSticky = function supportsPositionSticky() {
  return CSS && CSS.supports('position', 'sticky');
};